import { companyCreditCheck } from './companyCreditCheck'
import { getEanData } from './getEanData'
import { uploadPresigned } from './uploadPresigned'

export default {
  companyCreditCheck,
  getEanData,
  uploadPresigned
}
